// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__6_54v","range":"MonthRangeSwitch_range__aTPSf","disabled":"MonthRangeSwitch_disabled__16L5m"};